<a
    *appHasPermissionId="permissionList.userRead; else justNameTemplateRef"
    [routerLink]="['', 'user', 'detail', item.id]"
>
    {{ item.name }}
</a>
<ng-template #justNameTemplateRef>
    {{ item.name }}
</ng-template>
